import { Button, ButtonOptions } from "ui-pixijs";

interface UIButtonBaseOptions {
    cursor?: string;
    defaultTint?: number;
    hoverTint?: number;
    pressTint?: number;
}

export class UIButtonBase<TOptions extends ButtonOptions = ButtonOptions> extends Button {
    protected defaultTint;
    protected hoverTint;
    protected pressTint;

    protected _defaultScale: number = 1;
    public get defaultScale(): number {
        return this._defaultScale;
    }
    public set defaultScale(value: number) {
        this._defaultScale = value;
        this.pressScale = this._defaultScale - 0.1;
        this.defaultView.scale.set(this._defaultScale);

    }
    protected pressScale: number = 0.9;

    public constructor(options?: TOptions & UIButtonBaseOptions) {
        super(options);

        this.cursor = options.cursor ?? "hover";
        this.defaultTint = options.defaultTint ?? "#ffffff";
        this.hoverTint = options.hoverTint ?? "#dddddd";
        this.pressTint = options.pressTint ?? "#c9c9c9";

        this.on("pointerover", this.onHoverStart, this);
        this.on("pointerout", this.onHoverEnd, this);
        this.on("pointerdown", this.onPress, this);
        this.on("pointerup", this.onRelease, this);
        this.on("pointerupoutside", this.onReleaseOutside, this);
    }

    protected onHoverStart(): void {
        this.defaultView.tint = this.hoverTint;
    }

    protected onHoverEnd(): void {
        this.defaultView.tint = this.defaultTint;
    }

    protected onPress(): void {
        this.defaultView.tint = this.pressTint;
        this.setScaleWithOffset(this.pressScale);
    }

    protected onRelease(): void {
        this.defaultView.tint = this.hoverTint; // still hovering
        this.setScaleWithOffset(this.defaultScale);
    }

    protected onReleaseOutside(): void {
        this.defaultView.tint = this.defaultTint; // pointer left button
        this.setScaleWithOffset(this.defaultScale);
    }

    protected setScaleWithOffset(scale: number): void {
        if (!this.defaultView) return;

        const w = this.width / this.defaultView.scale.x; // original width (before current scaling)
        const h = this.height / this.defaultView.scale.y; // original height

        const offsetX = (w * (this.defaultScale - scale)) / 2;
        const offsetY = (h * (this.defaultScale - scale)) / 2;

        this.defaultView.scale.set(scale);
        this.defaultView.position.set(offsetX, offsetY);
    }

}
